// 일괄 응답 (기존)
export async function searchAll(query, { signal, sources } = {}) {
  const params = new URLSearchParams({ q: query });
  if (sources && sources.length) params.set('sources', sources.join(','));
  const res = await fetch(`/api/search?${params.toString()}`, { signal });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || `검색 실패 (${res.status})`);
  }
  return res.json();
}

// SSE 스트리밍. 소스가 완료될 때마다 onResult 콜백 호출.
// 반환값은 stream 을 중단할 수 있는 close() 함수.
export function searchStream(
  query,
  { sources, onStart, onResult, onDone, onError } = {}
) {
  const params = new URLSearchParams({ q: query });
  if (sources && sources.length) params.set('sources', sources.join(','));
  const es = new EventSource(`/api/search/stream?${params.toString()}`);

  const safeParse = (raw) => {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  };

  es.addEventListener('start', (e) => onStart && onStart(safeParse(e.data)));
  es.addEventListener('result', (e) => {
    const r = safeParse(e.data);
    if (r) onResult && onResult(r);
  });
  es.addEventListener('done', (e) => {
    if (onDone) onDone(safeParse(e.data));
    es.close();
  });
  es.onerror = (e) => {
    // 서버가 정상 종료(res.end) 했을 때도 EventSource는 onerror를 발생시킨다.
    // readyState === CLOSED 면 그냥 닫힘으로 간주.
    if (es.readyState === EventSource.CLOSED) return;
    if (onError) onError(e);
    es.close();
  };

  return () => es.close();
}
